import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import Entradas from "../../models/Entradas";

async function updateEntradas(entradas: Entradas): Promise<IResponse<ValidationResult>> {
  return await axios.put(`/Entrada/Put`, entradas);
}

export default updateEntradas;